// this file is generated by update_shopify_store_data.py at 2026-05-26 20:28:21.397631
var courses = [];